<p-dialog [visible]="!!updateData()" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
    header="Update Available" [style]="{ width: '650px' }">

    <div class="flex flex-col gap-4 mt-2">
        <div class="flex items-center gap-3">
            <i class="pi pi-info-circle text-blue-500 text-4xl"></i>
            <div>
                <p class="font-bold text-lg m-0">A new version is available!</p>
            </div>
        </div>

        @if (updateData()?.releaseNotes?.length) {
          <div class="bg-surface-50 dark:bg-surface-800 p-4 rounded-lg border border-surface-200 dark:border-surface-700">
              <p class="font-semibold mb-2">Release Notes:</p>
              <ul class="list-disc pl-5 m-0 space-y-1">
                  @for (note of updateData()?.releaseNotes; track $index) {
                    <li class="text-surface-600 dark:text-surface-400">{{note}}</li>
                  }
              </ul>
          </div>
        }

        <div class="flex justify-end gap-2 mt-2">
            <p-button label="Reload the application" icon="pi pi-refresh" iconPos="right" (click)="reload()" />
        </div>
    </div>
</p-dialog>
